import BaseFormValidationMixin from './BaseFormValidationMixin';

export default {
  mixins: {
    BaseFormValidationMixin,
  },

  props: {
    requestFormatter: {
      type: Function,
      default: (data) => data,
    },
  },

  data() {
    return {
      response: null,
      runningRequests: [],
    };
  },

  computed: {
    isLoading() {
      return this.runningRequests.length > 0;
    },
  },

  methods: {
    setErrors(errors) {
      Object.entries(errors).forEach(([key, error]) => {
        let path = null;
        if (key.includes('.')) {
          path = key.split('.');
        }

        function setToValue(obj, value, objPath) {
          let i;
          let currPath = objPath;
          currPath = currPath.split('.');

          // eslint-disable-next-line no-plusplus, no-param-reassign
          for (i = 0; i < currPath.length - 1; i++) obj = obj[currPath[i]];

          if (typeof obj[currPath[i]]?.error !== 'undefined') {
            // eslint-disable-next-line no-param-reassign
            obj[currPath[i]].error = value;
          }
        }

        if (path !== null && this.form[path[0]] instanceof Object) {
          const name = path[0];
          path.splice(0, 1);

          if (typeof this.form[path[0]] !== 'undefined' && typeof this.form[path[0]].value === 'undefined') {
            path = `${name}.${path.join('.')}`;
          } else {
            path = `${name}.value.${path.join('.')}`;
          }

          setToValue(this.form, error[0], path);
        } else if (this.form instanceof Array) {
          this.form.forEach((val, inx) => {
            Object.entries(errors).forEach(([x, y]) => {
              if (typeof this.form[inx][x] !== 'undefined') {
                // eslint-disable-next-line prefer-destructuring
                this.form[inx][x].error = y[0];
              }
            });
          });
        } else {
          // eslint-disable-next-line prefer-destructuring
          this.form[key].error = error[0];
        }
      });
    },
    forceUpdateComponent() {
      this.$nextTick(() => {
        if (Object.entries(this.$refs).filter(([key]) => key !== 'form').length) {
          this.$forceUpdate();
          Object.entries(this.$refs).filter(([key]) => key !== 'form').forEach(([, val]) => {
            if (val[0]) {
              val[0].$forceUpdate();
            }
          });
        }
      });
    },
    send(form, formAction, formMethod = 'post', forceUpdate = false, token = false, contentType = 'formData') {
      const formData = this.mapObject(form, contentType);

      if (token) {
        formData.append('_token', token);
      }

      const requestId = this.IOH.randomId();
      this.runningRequests.push(requestId);
      // eslint-disable-next-line no-undef
      axios[formMethod.toLowerCase()](formAction, formData, contentType !== 'json' ? {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      } : '')
        .then((res) => {
          if (res.data.message) {
            // eslint-disable-next-line no-undef
            GlobalEvents.fire('alert', [{ message: res.data.message, type: res.data.type || 'success' }]);
          } else if (res.data.messages instanceof Array) {
            if (res.data.messages[0].message) {
              // eslint-disable-next-line no-undef
              GlobalEvents.fire('alert', [{ message: res.data.messages[0].message, type: res.data.messages[0].type || 'success' }]);
            }
          }

          this.response = res;

          this.$emit('success', {
            response: res,
            value: {
              ...form,
              action: formAction,
              method: formMethod,
            },
            // eslint-disable-next-line no-undef
            fields: Object.fromEntries(_.compact(Object.entries(this.$refs).map(
              ([key, val]) => (Object.keys(form).indexOf(key) !== -1 ? [key, val[0]] : ''),
            ))),
          });

          if (this.response.data.redirectTo) {
            this.runningRequests.push(this.IOH.randomId());
            window.location.href = this.response.data.redirectTo;
          }
        })
        .catch((err) => {
          if (err.response.status === 422) {
            this.setErrors(err.response.data.errors);
          } else if (err.response.data.message) {
            // eslint-disable-next-line no-undef
            GlobalEvents.fire('alert', [{ message: err.response.data.message, type: 'error' }]);
          }

          try {
            this.mergeErrors();
          } catch (e) {
            // eslint-disable-next-line no-console
            console.error(e);
          }

          if (forceUpdate) {
            this.forceUpdateComponent();
          }

          const error = {
            response: err.response,
            // eslint-disable-next-line no-undef
            fields: Object.fromEntries(_.compact(Object.entries(this.$refs).map(
              ([key, val]) => (Object.keys(err.response.data.errors).indexOf(key) !== -1 ? [key, val[0]] : ''),
            ))),
          };

          this.response = error;
          this.$emit('error', error);
        }).finally(() => {
          this.runningRequests = this.runningRequests.filter((rId) => rId !== requestId);
        });
    },
    mapObject(obj, contentType) {
      const isArray = (val) => val instanceof Array;
      const isPath = (val) => val.includes('.');
      const isBoolean = (val) => typeof val === 'boolean';
      const boolToInt = (bool) => (bool ? 1 : 0);

      const formData = new FormData();

      if (contentType === 'json') {
        const JSON = {};
        Object.entries(obj).forEach(([key, val]) => {
          JSON[key] = val?.value;
        });

        return this.formRequestFormatter(JSON);
      }

      // eslint-disable-next-line no-restricted-syntax
      for (const key in obj) {
        // eslint-disable-next-line no-prototype-builtins
        if (obj.hasOwnProperty(key)) {
          if (isArray(obj[key].value)) {
            // eslint-disable-next-line no-plusplus
            for (let i = 0; i < obj[key].value.length; i++) {
              const name = obj[key].value.length >= 1 ? `${key}[${i}]` : key;
              const item = obj[key].value[i];
              const isFile = (val) => val instanceof File;
              const isObject = (val) => val instanceof Object;
              const isUndefined = (val) => typeof val === 'undefined';
              const getValidValue = (val, alt) => (typeof val === 'undefined' ? alt : val);

              const loop = (object, _name = '') => Object.entries(object).forEach(([_key, val]) => {
                const path = `${_name || name}[${_key}]`;
                const value = getValidValue(val?.value, val);

                if (
                  isArray(value)
                ) {
                  value.forEach((x) => {
                    if (isFile(x) && x.size >= 10) {
                      formData.append(path, x);
                    }
                  });
                } else if (isObject(val) && isUndefined(value)) {
                  loop(val, path);
                } else if (isBoolean(value)) {
                  formData.append(
                    path,
                    boolToInt(value),
                  );
                } else if (value !== null) {
                  formData.append(
                    path,
                    value || (isObject(val)
                      ? ''
                      : val),
                  );
                }
              });

              if (isFile(item) && item.size >= 10) {
                // Needs to be a single file if only one has been uploaded
                formData.append(obj[key].value.length > 1 ? `${key}[${i}]` : key, item);
              } else if (item instanceof Array) {
                if (item.length) {
                  formData.append(name, item);
                } else {
                  loop(item);
                }
              } else if (item instanceof Object) {
                loop(item);
              } else {
                formData.append(name, item);
              }
            }
          } else if (isPath(key)) {
            const arr = key.split('.');
            let name = '';
            arr.forEach((_key) => {
              name = name ? `${name}[${_key}]` : _key;
            });

            if (isBoolean(obj[key].value)) {
              formData.append(name, boolToInt(obj[key].value));
            } else if (typeof obj[key].value === 'number') {
              formData.append(name, obj[key].value);
            } else {
              // eslint-disable-next-line no-unused-expressions
              typeof obj[key].value !== 'undefined' ? formData.append(name, obj[key].value) : '';
            }
          } else if (isBoolean(obj[key].value)) {
            formData.append(key, boolToInt(obj[key].value));
          } else {
            // eslint-disable-next-line no-unused-expressions
            typeof obj[key].value !== 'undefined' && obj[key].value !== null ? formData.append(key, obj[key].value) : '';
          }
        }
      }

      return formData;
    },
  },
};
